<div class="relay-server-container">
  <section class="mat-typography heading">
      <div class="header-content">
        <br />
        <div class="heading-text">
          Relay Server Links Summary
        </div>
        <hr>
      </div>
  </section>
  <app-generic-table-header
    [config]="headerOptions"
    (refreshEvent)="refresh($event)"
    (viewPressed)="refresh($event)"
    (dropdownSelected)="dropDownSelect($event)"
    ></app-generic-table-header>
  @if (loading) {
<div>
    <br />
    <br />
    <mat-spinner class="mainSpinner" [diameter]="50"></mat-spinner>
    <br />
    <br />
  </div>
}
  @if (!loading) {
<div>
    <!-- <div class="date-picker">
      <button class="padded-btn button" matTooltip="Download CSV" mat-raised-button type="button" (click)="exportToCSV()">
            <i class="material-icons">cloud_download</i> Download CSV
          </button>
      <mat-form-field class="default-input">
        <input matInput required [max]="currentDay" [matDatepicker]="dp" placeholder="Month and Year" [formControl]="dateControl"
          (focus)="openPicker(dp)" (click)="openPicker(dp)" #elementToFocus>
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp="matDatepicker" startView="multi-year"
          (monthSelected)="chosenMonthHandler($event)" panelClass="example-month-picker">
        </mat-datepicker>
        <mat-error *ngIf="dateControl.hasError('required')">You must make a selection</mat-error>
      </mat-form-field>
    </div> -->
    
  </div>
}
  @if (!loading) {
<div class="table-container">
    <app-card-table
    [data]="dataToShow"
    [tableHeaders]="tableHeaders"
    [options]="options"
    [currentPage]="currentPage"
    [enableInfiteScroll]="false"
    [enableTablePagination]="true"
    [enableRefresher]="false"
    [totalItems]="data.length"
    [currentPage]="0"
    (paginateEvent)="onPageChange($event)"
    [breakpoint]="ScreenSize.TABLET">
    ></app-card-table>
    <br />
</div>
}
</div>
